import axios from "axios";
import {getConfig} from '../helpers/config';

export class BandoService {
    baseAPIUrl = `${getConfig()?.url}bandi`;

	getById = async (id) => {
		return await axios.get(`${this.baseAPIUrl}/${id}`)
											.then(res => res.data);
	}

	getAll = async () => {
		return await axios.get(`${this.baseAPIUrl}/`)
											.then(res => res.data);
	}

	getAllDt = async (data) => {
		return await axios.post(`${this.baseAPIUrl}/dt`, data)
											.then(res => res.data);
	}

	create = async (data) => {
		return await axios.post(`${this.baseAPIUrl}/`, data)
											.then(res => res.data);
	}

	update = async (data) => {
		return await axios.put(`${this.baseAPIUrl}/`, data)
											.then(res => res.data);
	}

	delete = async (id) => {
		return await axios.delete(`${this.baseAPIUrl}/${id}`)
											.then(res => res.data);
	}
}
